import * as React from "react";

import { Input } from "src/components/ui/input";
import { cn } from "src/lib/utils";
import { Field, type FieldProps } from "./Field";

export type TextFieldProps = Omit<React.ComponentProps<"input">, "children"> &
	Pick<FieldProps, "label" | "error" | "hint"> & {
		/** Class for the wrapping `<Field>`; `className` still reaches the `<input>`. */
		containerClassName?: string;
	};

/** Single-line text input in the standard label/error frame. */
export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
	({ label, error, hint, required, name, containerClassName, className, ...props }, ref) => (
		<Field label={label} name={name} required={required} error={error} hint={hint} className={containerClassName}>
			<Input
				ref={ref}
				id={name}
				name={name}
				aria-invalid={!!error}
				className={cn(error && "tw-border-red focus-visible:tw-border-red focus-visible:tw-ring-red/20", className)}
				{...props}
			/>
		</Field>
	)
);
TextField.displayName = "TextField";

export default TextField;
